/* eslint-env browser */
import { useEffect, useState } from 'react'

const getIsIOS = () => /iPhone|iPod/.test(navigator?.userAgent) || navigator?.platform === 'iPhone'

const useScrollToFragment = () => {
  useEffect(() => {
    const recheckScroll = (targetSection, headerHeight, maxRetries = 5) => {
      // Rechecks position of target after scroll to see if we've arrived at the correct position
      if (maxRetries <= 0) return
      setTimeout(() => {
        const expectedPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight
        const currentScroll = window.pageYOffset
        const diff = Math.abs(expectedPosition - currentScroll)
        if (diff > 2) {
          window.scrollTo({ top: expectedPosition, behavior: 'smooth' })
          recheckScroll(targetSection, headerHeight, maxRetries - 1)
        }
      }, 500)
    }

    const scrollToSection = () => {
      if (window.location.hash) {
        const fragment = window.location.hash
        const divArray = document.querySelectorAll(fragment)
        const isMobile = window.innerWidth < 639
        if (divArray.length === 0) return
        const targetSection = isMobile ? divArray[1] : divArray[0]
        const headerHeight = isMobile ? 130 : 120
        if (!targetSection) return
        targetSection.setAttribute('tabindex', '-1')
        const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        })
        recheckScroll(targetSection, headerHeight)
      }
    }

    scrollToSection()
  }, [])
}

export default useScrollToFragment
